module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9cfdd378e4cc977fe663ca932e530ec6.svg";